module.exports = __webpack_public_path__ + "static/media/3.18e54b00.png";